var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProspectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64404 6.28972C5.64404 7.29481 6.04331 8.25874 6.75401 8.96945C7.46471 9.68016 8.42863 10.0794 9.43371 10.0794C10.4388 10.0794 11.4027 9.68016 12.1134 8.96945C12.8241 8.25874 13.2234 7.29481 13.2234 6.28972C13.2234 5.28462 12.8241 4.32069 12.1134 3.60998C11.4027 2.89927 10.4388 2.5 9.43371 2.5C8.42863 2.5 7.46471 2.89927 6.75401 3.60998C6.04331 4.32069 5.64404 5.28462 5.64404 6.28972Z",
    stroke: "url(#paint0_linear_1798_40700)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 19.5518V17.6569C3.75 16.6518 4.14927 15.6879 4.85997 14.9772C5.57067 14.2665 6.53458 13.8672 7.53967 13.8672H8.96079",
    stroke: "url(#paint1_linear_1798_40700)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2764 16.7095C12.2764 17.4633 12.5758 18.1862 13.1088 18.7193C13.6419 19.2523 14.3648 19.5518 15.1186 19.5518C15.8724 19.5518 16.5954 19.2523 17.1284 18.7193C17.6614 18.1862 17.9609 17.4633 17.9609 16.7095C17.9609 15.9557 17.6614 15.2327 17.1284 14.6997C16.5954 14.1666 15.8724 13.8672 15.1186 13.8672C14.3648 13.8672 13.6419 14.1666 13.1088 14.6997C12.5758 15.2327 12.2764 15.9557 12.2764 16.7095Z",
    stroke: "url(#paint2_linear_1798_40700)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2046 18.793L18.9099 20.4983",
    stroke: "url(#paint3_linear_1798_40700)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40700",
    x1: 9.43371,
    y1: 2.5,
    x2: 9.43371,
    y2: 10.0794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#990094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40700",
    x1: 6.3554,
    y1: 13.8672,
    x2: 6.3554,
    y2: 19.5518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#990094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1798_40700",
    x1: 15.1186,
    y1: 13.8672,
    x2: 15.1186,
    y2: 19.5518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#990094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1798_40700",
    x1: 18.0573,
    y1: 18.793,
    x2: 18.0573,
    y2: 20.4983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#990094"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectsIcon);
export default __webpack_public_path__ + "static/media/prospects-icon.4ff2e29d2a51454070709e631f22770b.svg";
export { ForwardRef as ReactComponent };